export default __webpack_public_path__ + "static/media/Interior (3).d0df6f0a.jpg";